
import { Component, Vue, Prop } from 'vue-property-decorator';
@Component
export default class CommonLoad extends Vue {
  @Prop() private loadStyle!: object;
}
